import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import DataGrid from '../../../../common/components/Form/DataGrid/DataGrid'

import { API__ANALYTICS } from '../../../../api'

import { downloadFile } from '../../../../common/utils/files'

import DateRangePanel from '../DateRangePanel/DateRangePanel'
import { generateNameCSVFile } from '../../utils'
import { columns } from './columns'

import './LeadFormTable.scss'

const LeadFormTable = ({ projectId, isHideTitle = false }) => {
    const { t } = useTranslation()
    const { blockId } = useParams()
    const [dateRange, setDateRange] = useState(null)

    const [isReady, setIsReady] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState(null)

    async function fetchData(page = 0) {
        setIsLoading(true)
        const result = await API__ANALYTICS.GET_BLOCK_LEAD_FORM(projectId, blockId, {
            size: 20,
            page,
            from: dateRange.from,
            to: dateRange.to,
        })
        setData(result)
        setIsLoading(false)
        setIsReady(true)
    }

    useEffect(() => {
        if (dateRange) fetchData()
    }, [dateRange])

    async function onExportCSV() {
        const content = await API__ANALYTICS.GET_BLOCK_LEAD_FORM_CSV({
            projectId,
            blockId,
            from: dateRange.from,
            to: dateRange.to,
        })
        const fileName = generateNameCSVFile(t('Lead form'), dateRange.from, dateRange.to)
        downloadFile(content, `text/csv`, fileName)
    }

    return (
        <div className="lead-form-analytics">
            {!isHideTitle && <h1>{t('Lead form')}</h1>}
            <DateRangePanel onChangeRange={v => setDateRange(v)} isEnableCSV onExportCSV={onExportCSV} />
            {isReady ? (
                <DataGrid
                    columns={columns}
                    isLoading={isLoading}
                    pagination={data}
                    onPageChange={page => fetchData(page)}
                />
            ) : null}
        </div>
    )
}

export default LeadFormTable
